import React from 'react'

const SvgChevronLeft = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path d="M10.475 14.158L4.818 8.501l.707-.707 5.657 5.657z" />
    <path d="M11.181 3.548L5.524 9.205l-.707-.707 5.657-5.657z" />
  </svg>
)

export default SvgChevronLeft
